export default "__VITE_ASSET__P7JIyfvv__"